import React, { useEffect } from 'react';
import LegalSidebar from '../components/LegalSidebar';
import { setPageSEO } from '../utils/seo.js';
import './Terms.css';

function ThirdPartyLinks() {
  useEffect(() => setPageSEO({
    title: 'Third-Party Links Policy - Clientalio',
    description: "Learn about Clientalio's policies regarding third-party websites, services, and external integrations referenced on our platform.",
    canonical: 'https://clientalio.com/third-party-links',
    ogTitle: 'Third-Party Links Policy - Clientalio',
    ogDescription: "Learn about Clientalio's policies regarding third-party websites, services, and external integrations referenced on our platform.",
    twitterTitle: 'Third-Party Links Policy - Clientalio',
    twitterDescription: "Learn about Clientalio's policies regarding third-party websites, services, and external integrations referenced on our platform."
  }), []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-header">
          <h1>Third-Party Links Policy</h1>
          <p className="last-updated">Last Updated: 06-Oct-2025</p>
        </div>
        <div className="terms-layout">
          <LegalSidebar activePage="third-party-links" />

          {/* Main Content */}
          <div className="terms-content">
            <div className="content-section">

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  At Clientalio, transparency and user trust are at the core of everything we do.
                  This Third-Party Links Policy explains how we handle links to other websites or
                  services that are not operated by us.
                </p>
              </section>

              <section className="terms-section">
                <h2>2. Third-Party Links on Our Website</h2>
                <p>
                  Our website may include links to third-party websites, tools, or integrations
                  for your convenience. These sites are not controlled by Clientalio and we are not
                  responsible for their content, policies, or data handling practices.
                </p>
                <p>
                  We recommend reviewing any third-party privacy and cookie policies before
                  sharing personal information.
                </p>
              </section>

              <section className="terms-section">
                <h2>3. Use of Third-Party Services</h2>
                <p>
                  To deliver certain features, we may rely on trusted third-party services. Each
                  provider is vetted and operates under GDPR-compliant contracts. If a partner is
                  located outside the EEA, we use approved safeguards such as Standard Contractual
                  Clauses.
                </p>
              </section>

              <section className="terms-section">
                <h2>4. Liability Disclaimer</h2>
                <p>
                  Clientalio cannot be held responsible for damages or data loss arising from use
                  of external sites. Accessing third-party links is at your own risk.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThirdPartyLinks;
